import React, { Fragment } from "react";
import { withStyles } from "@material-ui/core/styles";
import { IconButton } from "@material-ui/core";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  DialogActions,
  Button,
  Checkbox,
} from "@material-ui/core";
import { NumericEditor, DateTimeEditor } from "../../dataGrid/cellEditors";
import { convertTimeToMinute, formatTime } from "../../dataGrid/gridUtilities";
import ErrorIcon from "@material-ui/icons/Error";
import CloseIcon from "@material-ui/icons/Close";
import Tooltip from "../../common/StyledToolTip";
import DynamicRoutingAnimation from "../DialogAnimations/DynamicRoutingAnimation";
import appConstants from "../../../appConstants";
import * as MergingRoutesAnimation from "../DialogAnimations/MergingRoutesAnimation.json";
import * as ReadingDataAnimation from "../DialogAnimations/ReadingDataAnimation.json";
import * as BuildingRoutesAnimation from "../DialogAnimations/BuildingRoutesAnimation.json";
import * as SuccessAnimation from "../DialogAnimations/SuccessAnimation.json";
import Slide from "@material-ui/core/Slide";
import EquipmentTypes from "./EquipmentTypes";
import ReturnToTerminalIcon from "../../modules/IBPlanning/Common/ReturnToTerminalIcon";
import { compose } from "recompose";
import { withFeatureFlags } from "../../../userProfile/featureFlagsContext";
import ToggleRenderer from "../../dataGrid/cellRenderer/toggleRenderer";
import { withAppConfig } from "../../../appConfigContext";

const styles = (theme) => ({
  dialogContainer: {
    padding: 16,
    userSelect: "none",
    backgroundColor: theme.ModalBGColor,
    maxWidth: 780,
  },
  dialogTitle: {
    fontSize: 16,
    fontWeight: 600,
    color: theme.HeaderSelectedText,
  },
  dialogContent: {
    overflowY: "visible",
  },
  legend: {
    fontSize: 14,
    fontWeight: 600,
    color: theme.HeaderSelectedText,
    padding: "0px 8px",
  },
  gridContainer: {
    padding: "12px 16px",
  },
  gridItemHead: {
    fontWeight: 600,
  },
  gridItem: {
    fontSize: theme.textFontSize,
    color: theme.gridTextColor,
    "&>div": {
      marginTop: 0,
    }
  },
  fieldSet: {
    borderWidth: 1,
    borderColor: theme.AppBGColor,
  },
  closeIconStyle: {
    padding: "0px",
    float: "right",
    color: theme.HeaderDefaultTextColor,
    "&:hover": {
      backgroundColor: theme.ModalBGColor,
      color: theme.HeaderSelectedText,
    },
  },
  fieldsetTopMargin: {
    marginTop: 24,
  },
  actionContainer: {
    display: "flex",
    width: "60%",
    justifyContent: "space-between",
  },
  dialogActionStyle: {
    padding: "0px 24px",
  },

  dialogButtonStyle: {
    fontSize: 14,
    textTransform: "none",
    borderRadius: "2px",
    float: "right",
    width: "48%",
    "&$disabledButton,&$disabledButton:hover": {
      cursor: "not-allowed",
      pointerEvents: "all",
      backgroundColor: theme.headerIconColor,
      color: "white",
    },
  },
  warningMessage: {
    fontSize: 14,
    fontWeight: 600,
    color: theme.ErrorMessageColor,
    padding: "16px 0 0 0",
  },
  errorColor: {
    color: theme.ErrorMessageColor,
  },
  closeIcon: {
    fontSize: 24,
  },
  errorContainer: {
    color: theme.ErrorMessageColor,
    border: `1px solid ${theme.ErrorMessageColor}`,
    backgroundColor: "rgba(215,103,103,0.3)",
    borderRadius: 2,
    display: "inline-flex",
    margin: "0 12px",
    "&>span": {
      padding: "0 8px",
    },
  },
  disabledButton: {
    cursor: "not-allowed",
    pointerEvents: "all",
    backgroundColor: theme.iconColor,
    color: "white",
  },
  buttonLabel: {
    width: "100%",
  },
  inputError: {
    "&>div": {
      borderColor: theme.ErrorMessageColor,
    },
  },
  progressDialogTitle: {
    fontSize: "25px",
    fontWeight: 600,
    textAlign: "center",
    lineHeight: "34px",
    color: theme.HeaderSelectedText,
  },
  drProgressContent: {
    fontSize: "16px",
    lineHeight: "17px",
    overflow: "hidden",
    color: theme.TextColor,
  },
  percentageComplete: {
    padding: "24px 0px",
    textAlign: "center",
    fontStyle: "italic",
    color: theme.gridTextColor,
    lineHeight: "22px",
  },
  didYouKnowTitle: {
    textAlign: "center",
    fontWeight: 600,
    lineHeight: "22px",
    color: theme.HeaderSelectedText,
    paddingTop: "24px",
  },
  factsWrapper: {
    color: theme.gridTextColor,
    textAlign: "center",
    fontStyle: "italic",
    lineHeight: "34px",
    padding: "12px 0px",
  },
  hideMessage: {
    display: "none",
  },
  returnToTerminalWrapper: { display: "flex", alignItems: "center" },
  checkbox: {
    padding: 0,
    marginRight: 8,
    color: theme.iconColor,
  },
  returnToTerminalLabel: {
    marginRight: 8,
  },
  headerLabel: {
    fontSize: theme.textFontSize,
    padding: "12px 24px 0px 24px",
    fontWeight: 500,
    textTransform: "uppercase",
    color: theme.dispatchPanelHeaderColor,
  },
  itemRow:{
    display:"flex",
    direction:"row"
  },
  dockCuttOffLabel:{
      paddingRight: 8,
      lineHeight:"24px"
  },
  dockTextLabel:{
    lineHeight:"30px"
  },
  dockValueContainer:{
    padding:"12px 0px"
  },
});
class DynamicRoutingDialog extends React.Component {
  constructor(props) {
    super(props);
    // this.expectedRouteCount = React.createRef();
    this.lastWaveCutOffTime = React.createRef();
    this.maxStopsPerRouteCount = React.createRef();
    this.dockCutOffTime = React.createRef();
    this.state = {
      constraintError: "",
      errorField: "",
      enableConfirm: true,
      openDialog: this.props.inProgress
        ? this.props.inProgress
        : this.props.show,
      progressPercentage: this.props.dynamicRoutingProgressValue,
      selectedRoutesMessage: this.getSelectedRouteMessage(),
      isReturnToTerminal : false,
      useDockCutOffTime: false
    };
    const factsArray = appConstants.DYNAMIC_ROUTING_PROGRESS_MESSAGES;
    this.didYouKnowText =
      factsArray[Math.floor(Math.random() * factsArray.length)];
    this.trailerTypeList = [];
    this.trailerTypeCountList = [];
    this.tractorTypeCountList = [];
    this.isFFEConfig = this.props.configJSON?.showDateRangeInShipmentSelection;
  }

  componentDidMount() {
    // Move focus to the first input after first render
    // setTimeout(() => {
    //       this.liftgateTrailerCount.current && this.liftgateTrailerCount.current.focusOnInput();
    // }, 0);
  }

  componentDidUpdate(prevProps) {
    //update dynamic routing progress percentage iff it is greater than the previous value
    if (
      this.props.dynamicRoutingProgressValue >
      prevProps.dynamicRoutingProgressValue
    ) {
      this.setState({
        progressPercentage: this.props.dynamicRoutingProgressValue,
      });
    }

    //After dynamic routing completion, keep dialog open for sometime to show success animation
    if (this.props.isCompleted) {
      setTimeout(() => {
        this.props.onClose();
      }, 2000);
    }
  }

  getSelectedRouteMessage = () => {
    const selectedRoutes = [];
    const { data } = this.props;

    data.totalLockedRoutes &&
      selectedRoutes.push(`${data.totalLockedRoutes} locked`);
    data.totalUnlockedRoutes &&
      selectedRoutes.push(`${data.totalUnlockedRoutes} unlocked`);
    data.totalPartialLockedRoutes &&
      selectedRoutes.push(`${data.totalPartialLockedRoutes} partially locked`);

    let message = "";
    const totalRoutes =
      data.totalLockedRoutes +
      data.totalUnlockedRoutes +
      data.totalPartialLockedRoutes;

    switch (selectedRoutes.length) {
      case 1:
        message = selectedRoutes[0];
        break;
      case 2:
        message = selectedRoutes.join(" and ");
        break;
      default:
        message =
          selectedRoutes.slice(0, selectedRoutes.length - 1).join(" , ") +
          " and " +
          selectedRoutes[selectedRoutes.length - 1];
        break;
    }
    return message
      ? `${message} ${
      totalRoutes === 1 ? " route is selected" : " routes are selected"
      }`
      : "";
  };

  populateInititalTrailerTypeCountList=()=>{
    const {data}=this.props;
    this.trailerTypeCountList=data.trailersData.map(trailerData=>{
      return {
        trailerCount: null, trailerId: trailerData.trailerId
      }
    })
  }
  populateInititalTractorTypeCountList=()=>{
    const {data}=this.props;
    this.tractorTypeCountList = data.tractorsData.map((tractorsData) => {
      return {
        tractorCount: null,
        tractorId: tractorsData.tractorId,
      };
    });
  }
  onConfirm = () => {
    // const expectedRouteCount = this.expectedRouteCount.current.getValue();
    this.trailerTypeCountList.length===0 && this.populateInititalTrailerTypeCountList();
    this.tractorTypeCountList.length === 0 &&
      this.populateInititalTractorTypeCountList();
    const trailers = this.trailerTypeCountList;
    const tractors = this.tractorTypeCountList;
    const lastWaveCutOff = convertTimeToMinute(
      this.lastWaveCutOffTime.current.getValue()
    );
    const dockCutOffTime = this.state.useDockCutOffTime ? formatTime({value:this.dockCutOffTime.current.getValue()},"HH:mm") : undefined
    const maxStopsPerRouteCount = this.maxStopsPerRouteCount.current.getValue();
    const { data } = this.props;

    let error = "";
    let field = "";

    // if(!expectedRouteCount){
    //     error = "Please enter a valid input for routes - More than zero",
    //     field = "expectedRouteCount";
    //     this.expectedRouteCount.current && this.expectedRouteCount.current.focusOnInput();
    // } else if(Number(liftgateTrailerCount || 0) > this.props.data.optimizationConstraints.maxLiftgateTrailerAvailable){
    //     error = "Liftgates to be used exceeds available liftgates at the terminal";
    //     field = "liftgateTrailerCount";
    //     this.liftgateTrailerCount.current && this.liftgateTrailerCount.current.focusOnInput();
    // } else
    if (!maxStopsPerRouteCount) {
      (error = "Please enter a valid input for max stops - More than zero"),
        (field = "maxStopsPerRouteCount");
      this.maxStopsPerRouteCount.current &&
        this.maxStopsPerRouteCount.current.focusOnInput();
    }

    if (error) {
      this.setState({
        constraintError: error,
        errorField: field,
        enableConfirm: error ? false : true,
      });
    } else {
      const { isReturnToTerminal } = this.state;
      this.props.triggerDynamicRouting &&
        this.props.triggerDynamicRouting({
          maxStopsPerRoute: maxStopsPerRouteCount,
          lastWaveCutOff,
          dockCutOffTime,
          trailers,
          tractors,
          numberOfExpectedRoutes: 0, // needs to be sent since api structure expects this field but doesn't read this value
          routeNames: data.selectedRoutes,
          isReturnToTerminal,
        });
      //this.props.onClose && this.props.onClose();
    }
  };

  updateAnimation = (progress) => {
    if (this.props.isCompleted) {
      return {
        animationText: "Success",
        animationData: SuccessAnimation.default,
      };
    } else {
      if (progress === 0) {
        return {
          animationText: "Job Queued",
          animationData: ReadingDataAnimation.default,
        };
      } else if (progress <= 30) {
        return {
          animationText: "Reading Data",
          animationData: ReadingDataAnimation.default,
        };
      } else if (progress > 30 && progress <= 60) {
        return {
          animationText: "Building Routes",
          animationData: BuildingRoutesAnimation.default,
        };
      } else {
        return {
          animationText: "Merging Routes",
          animationData: MergingRoutesAnimation.default,
        };
      }
    }
  };

  onChange = () => {
    this.setState({
      enableConfirm: true,
    });
  };

  onDialogClosed = () => {
    if (!this.props.inProgress) {
      this.props.onClose();
    }
  };

  updateTrailerTypeCount = (countRef) => {
    this.trailerTypeCountList = Object.keys(countRef).map((key) => {
      return {
        trailerCount:
          countRef[key] && typeof countRef[key].getValue() === "number"
            ? countRef[key].getValue()
            : null,
        trailerId: countRef[key].props.equipmentId,
      };
    });
  };

  updateTractorTypeCount = (countRef) => {
    this.tractorTypeCountList = Object.keys(countRef).map((key) => {
      return {
        tractorCount:
          countRef[key] && typeof countRef[key].getValue() === "number"
            ? countRef[key].getValue()
            : null,
        tractorId: countRef[key].props.equipmentId,
      };
    });
  };
  
  handleIsReturnToTerminal = (event) => {
    this.setState({
      isReturnToTerminal : event.target.checked
    })
  }

  toggleUseDockCutOffTime = () => {
    this.setState(prevState =>({
        useDockCutOffTime: !prevState.useDockCutOffTime
    }))
  }

  render() {
    const {
      classes,
      data,
      inProgress,
      dynamicRoutingProgressValue,
    } = this.props;
    const { animationText, animationData } = this.updateAnimation(
      this.state.progressPercentage
    );
    const hideReturnToTerminalOption = this.props.featureFlags.isFeatureEnabled(
      appConstants.features.DisableReturnToTerminalOption
    );
    const { useDockCutOffTime} = this.state;
    return (
      <Dialog
        open={this.state.openDialog}
        onClose={this.onDialogClosed}
        classes={{ paper: classes.dialogContainer }}
        aria-labelledby="dynamic-routing"
      >
        <DialogTitle
          classes={{
            root: `${
              inProgress ? classes.progressDialogTitle : classes.dialogTitle
            }`,
          }}
          disableTypography
        >
          {inProgress
            ? "Dynamic Routing in progress"
            : `Dynamic Routing: ${data.totalRoutes} Routes will be affected`}
          {!inProgress && (
            <IconButton
              aria-label="Close"
              classes={{ root: classes.closeIconStyle }}
              onClick={this.onDialogClosed}
            >
              <CloseIcon classes={{ root: classes.closeIcon }} />
            </IconButton>
          )}
        </DialogTitle>
        <DialogContent
          className={
            inProgress ? classes.drProgressContent : classes.dialogContent
          }
        >
          {!inProgress ? (
            <div>
              <fieldset className={classes.fieldSet}>
                <legend className={classes.legend}>
                  {" "}
                  Selected Shipment Details{" "}
                </legend>
                <Grid
                  container
                  spacing={24}
                  classes={{ container: classes.gridContainer }}
                >
                  <Grid
                    item
                    xs={12}
                    classes={{
                      item: `${classes.gridItemHead} ${classes.gridItem} ${
                        data.totalLockedRoutes ? classes.errorColor : ""
                      }`,
                    }}
                  >
                    {this.state.selectedRoutesMessage}
                  </Grid>
                  {data.shipmentDetails &&
                    Object.keys(data.shipmentDetails).map((key) => (
                      <Fragment key={key}>
                        <Grid
                          item
                          xs={6}
                          sm={2}
                          classes={{ item: classes.gridItem }}
                        >
                          {key}
                        </Grid>
                        <Grid
                          item
                          xs={6}
                          sm={2}
                          classes={{ item: classes.gridItem }}
                        >
                          {data.shipmentDetails[key]}
                        </Grid>
                      </Fragment>
                    ))}
                  {data.error ? (
                    <Grid
                      item
                      xs={12}
                      classes={{
                        item: `${classes.gridItemHead} ${classes.gridItem} ${classes.errorContainer}`,
                      }}
                    >
                      <ErrorIcon classes={{ root: classes.errorColor }} />{" "}
                      <span>{data.error}</span>
                    </Grid>
                  ) : null}
                </Grid>
              </fieldset>
              <fieldset
                className={`${classes.fieldSet} ${classes.fieldsetTopMargin}`}
              >
                <legend className={classes.legend}>
                  {" "}
                  Optimization Constraints{" "}
                </legend>
                {Boolean(data.trailersData.length) && (
                  <Grid
                    container
                    alignItems="center"
                    spacing={24}
                    classes={{ container: classes.gridContainer }}
                  >
                    <EquipmentTypes
                      data={data.trailersData.map((item) => ({
                        equipmentName: item.trailerName,
                        equipmentId: item.trailerId,
                        tempType: this.isFFEConfig ? item.tempType : null
                      }))} 
                      updateEquipmentTypeCount={this.updateTrailerTypeCount}
                    />
                  </Grid>
                )}

                {Boolean(data.tractorsData.length) && (
                  <Grid
                    container
                    alignItems="center"
                    spacing={24}
                    classes={{ container: classes.gridContainer }}
                  >
                    <EquipmentTypes
                      data={data.tractorsData.map((item) => ({
                        equipmentName: item.tractorName,
                        equipmentId: item.tractorId,
                      }))}
                      updateEquipmentTypeCount={this.updateTractorTypeCount}
                    />
                  </Grid>
                )}
                <Grid
                  container
                  alignItems="center"
                  spacing={24}
                  classes={{ container: classes.gridContainer }}
                >
                  <Grid item xs={12}>
                    <Grid container spacing={24}>
                      <Grid
                        item
                        xs={6}
                        sm={3}
                        md={2}
                        classes={{
                          item: `${classes.gridItemHead} ${classes.gridItem}`,
                        }}
                      >
                        Max stops per route:
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        sm={3}
                        md={2}
                        classes={{
                          item: `${classes.gridItem} ${
                            this.state.errorField === "maxStopsPerRouteCount"
                              ? classes.inputError
                              : ""
                          }`,
                        }}
                      >
                        <NumericEditor
                          ref={this.maxStopsPerRouteCount}
                          value={
                            data.optimizationConstraints.maxStopsPerRouteCount
                          }
                          onChange={this.onChange}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        sm={3}
                        md={2}
                        classes={{
                          item: `${classes.gridItemHead} ${classes.gridItem}`,
                        }}
                      >
                        Last wave cutoff:
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        sm={3}
                        md={2}
                        classes={{ item: `${classes.gridItem}` }}
                      >
                        <DateTimeEditor
                          dateType={appConstants.DATETYPES.TIME}
                          onChange={this.onDateChanged}
                          value={data.optimizationConstraints.lastWaveCutOff}
                          ref={this.lastWaveCutOffTime}
                        />
                      </Grid>
                      {!hideReturnToTerminalOption && (
                        <Grid
                          item
                          xs={12}
                          classes={{
                            item: `${classes.gridItemHead} ${classes.gridItem}`,
                          }}
                          className={classes.returnToTerminalWrapper}
                        >
                          <Checkbox
                            color="primary"
                            className={classes.checkbox}
                            checked={this.state.isReturnToTerminal}
                            onChange={this.handleIsReturnToTerminal}
                          />
                          <span className={classes.returnToTerminalLabel}>
                            Return routes directly to terminal after final
                            delivery
                          </span>
                          <ReturnToTerminalIcon width={28} height={28} />
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  container
                  alignItems="center"
                  spacing={24}
                  classes={{ container: classes.gridContainer }}
                >
                  <Grid item xs={12}>
                    <Grid
                      item
                      classes={{
                        item: `${classes.gridItemHead} ${classes.gridItem} ${classes.itemRow}`,
                      }}
                    >
                      <Grid className={classes.dockTextLabel}>
                        {this.isFFEConfig ? 'Set earliest route start time' : 'Calculate preparation time based on the dock cutoff time'}
                      </Grid>
                      <ToggleRenderer
                        value={useDockCutOffTime}
                        onChange={this.toggleUseDockCutOffTime}
                      />
                    </Grid>
                    {useDockCutOffTime ? (
                      <>
                        <Grid
                          item
                          classes={{
                            item: `${classes.gridItemHead} ${classes.gridItem} ${classes.itemRow} ${classes.dockValueContainer}`,
                          }}
                        >
                          <Grid className={classes.dockCuttOffLabel}>{this.isFFEConfig? 'Start Time:': 'Dock cutoff:'}</Grid>
                          <DateTimeEditor
                            dateType={appConstants.DATETYPES.TIME}
                            value={data.optimizationConstraints.dockCutOffTime}
                            ref={this.dockCutOffTime}
                          />
                        </Grid>
                      </>
                    ) : null}
                  </Grid>

                  {this.state.constraintError ? (
                    <Grid
                      item
                      xs={12}
                      classes={{
                        item: `${classes.gridItemHead} ${classes.gridItem} ${classes.errorContainer}`,
                      }}
                    >
                      <ErrorIcon classes={{ root: classes.errorColor }} />{" "}
                      <span>{this.state.constraintError}</span>
                    </Grid>
                  ) : null}
                </Grid>
              </fieldset>
              <div className={classes.warningMessage}>
                Note: This action cannot be reversed.
              </div>
            </div>
          ) : (
            <div>
              <DynamicRoutingAnimation
                dimension={280}
                animationJSON={animationData}
              />
              {this.state.progressPercentage === 0 ? (
                <div className={classes.percentageComplete}>
                  {animationText}
                </div>
              ) : (
                <div className={classes.percentageComplete}>
                  {animationText}:{" "}
                  {dynamicRoutingProgressValue >= 100
                    ? 100
                    : this.state.progressPercentage}
                  % completed
                </div>
              )}
              <div className={classes.didYouKnowTitle}>Did You Know?</div>
              <div className={classes.factsWrapper}>
                <Slide direction="right" in={true}>
                  <div>{this.didYouKnowText}</div>
                </Slide>
              </div>
            </div>
          )}
        </DialogContent>
        {!inProgress && (
          <DialogActions classes={{ root: classes.dialogActionStyle }}>
            <div className={classes.actionContainer}>
              <Button
                variant="outlined"
                onClick={this.onDialogClosed}
                color="primary"
                size="medium"
                className={classes.dialogButtonStyle}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={this.onConfirm}
                color="primary"
                size="medium"
                classes={{
                  root: classes.dialogButtonStyle,
                  disabled: classes.disabledButton,
                }}
                disabled={Boolean(!this.state.enableConfirm || data.error)}
              >
                <Tooltip
                  title={`${
                    data.totalLockedRoutes
                      ? "Cannot optimize as locked routes are selected"
                      : !this.state.enableConfirm
                      ? "Cannot optimize due to incorrect constraints"
                      : ""
                  }`}
                >
                  <span className={classes.buttonLabel}> Confirm </span>
                </Tooltip>
              </Button>
            </div>
          </DialogActions>
        )}
      </Dialog>
    );
  }
}

export default compose(
  withFeatureFlags,
  withStyles(styles),
  withAppConfig
)(DynamicRoutingDialog);
